import { useMutation } from 'react-query';
import request from '../../../../../helpers/request';

const getAttachmentsByName = async (value) => {
  return await request.get(
    '/Access/transport/attachments',
    value,
    'При загрузке данных документа произошла ошибка',
    'Error'
  );
};

const useDocByName = () =>
  useMutation(getAttachmentsByName, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

export default useDocByName;
